import { useEffect, useState } from 'react'
import { apiFetch, ApiError } from '../lib/apiClient'
import type { AccountSummary } from '../types/tenant'

interface AccountsState {
  accounts: AccountSummary[]
  isLoading: boolean
  error: ApiError | null
}

export function useTenants(): AccountsState {
  const [accounts, setAccounts] = useState<AccountSummary[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<ApiError | null>(null)

  useEffect(() => {
    let cancelled = false
    apiFetch<{ tenants: AccountSummary[] }>('/api/accounts')
      .then(data => { if (!cancelled) setAccounts(data.tenants) })
      .catch(err => { if (!cancelled) setError(err instanceof ApiError ? err : new ApiError(500, 'UNKNOWN')) })
      .finally(() => { if (!cancelled) setIsLoading(false) })
    return () => { cancelled = true }
  }, [])

  return { accounts, isLoading, error }
}
